import React, { ReactChild } from 'react';
import uuid from 'uuid/v4';

import { IMaterialDataTableItem, TValidContentTypes, IWithActionButtonProps } from '../../prop-types';
import ConfirmationIcons from '../ActionIcons/ConfirmationIcons';
import EditCheckbox from '../EditFields/EditCheckbox';
import EditDate from '../EditFields/EditDate';
import EditInput from '../EditFields/EditInput';
import TableRow from '../table/TableRow';
import TableCell from '../table/TableCell';
import EditSelectInput from '../EditFields/EditSelectInput';

interface IEditRowProps extends IWithActionButtonProps {
  cells: IMaterialDataTableItem<TValidContentTypes>[];
  onValueChange: <T extends TValidContentTypes>(
    value: T,
    index: number
  ) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function EditRow({
  cells,
  onValueChange,
  onConfirm,
  onCancel,
  ...props
}: IEditRowProps) {

  const getCellContent = (
    content: TValidContentTypes,
    index: number,
    options?: string[],
  ): JSX.Element => {
    switch (typeof content) {
      case "boolean": {
        return (
          <EditCheckbox
            value={content}
            onChange={v => onValueChange<boolean>(v, index)}
          />
        );
      }
      case "object": {
        return (
          <EditDate
            value={content}
            onChange={v => onValueChange<Date>(v, index)}
          />
        );
      }
      default: {
        const type = typeof content === "string" ? "text" : "number";
        if(options && options.length > 0) {
          return (
            <EditSelectInput
              value={content}
              options={options}
              onChange={v => onValueChange<string>(v, index)}
            />
          )
        } else {
          return (
            <EditInput
              type={type}
              value={content}
              onChange={v => onValueChange<string>(v, index)}
            />
          );
        }
      }
    }
  };

  return (
    <TableRow className="material-data-table--tableRow_edit">
      <TableCell>
        <ConfirmationIcons {...props} onConfirm={onConfirm} onCancel={onCancel} />
      </TableCell>
      <>
        {cells.map((rowItem, index): ReactChild => (
          <TableCell key={uuid()} {...rowItem.props}>
            {getCellContent(rowItem.content, index, rowItem.options)}
          </TableCell>
        ))}
      </>
    </TableRow>
  );
}
